module.exports = __webpack_public_path__ + "static/media/First-Category.4cd8456b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/First-Category.jpg
// module id = 120
// module chunks = 0